module.exports = __webpack_public_path__ + "img/_icon-track.71878629.svg";